import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { fmtISTDay } from "@/lib/ist";

const NOTIFY = { sent: "Owner emailed", failed: "Email failed", sending: "Sending", no_owner_email: "No owner email set" };

export const OwnerEnquiriesAdmin = ({ enquiries }) => (
  <div data-testid="admin-section-enquiries">
    <h1 className="text-3xl font-display font-semibold text-navy">Owner Enquiries</h1>
    <p className="text-sm text-gray-500 mt-1">Messages sent from each region's "Connect with the owner" form.</p>
    <div className="mt-8 bg-white border border-gray-200 rounded-2xl overflow-x-auto">
      <Table>
        <TableHeader><TableRow><TableHead>Name</TableHead><TableHead>Contact</TableHead><TableHead>Region</TableHead><TableHead>Message</TableHead><TableHead>Owner</TableHead><TableHead>Date</TableHead></TableRow></TableHeader>
        <TableBody>
          {enquiries.map((e) => (
            <TableRow key={e.id} data-testid={`enquiry-row-${e.id}`}>
              <TableCell className="font-medium">{e.name}<div className="text-xs text-gray-500">{e.business_name}</div></TableCell>
              <TableCell><div className="text-xs">{e.email}</div><div className="text-xs text-gray-500">{e.phone}</div></TableCell>
              <TableCell>{e.city}</TableCell>
              <TableCell className="max-w-[280px] text-sm text-gray-600 whitespace-pre-line">{e.message || "—"}</TableCell>
              <TableCell><Badge variant={e.owner_notified === "sent" ? "default" : "secondary"}>{NOTIFY[e.owner_notified] || e.owner_notified}</Badge></TableCell>
              <TableCell className="text-xs text-gray-500">{fmtISTDay(e.created_at)}</TableCell>
            </TableRow>
          ))}
          {enquiries.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-gray-500 py-8">No enquiries yet.</TableCell></TableRow>}
        </TableBody>
      </Table>
    </div>
  </div>
);
